export default {
    formatCurrency: (value) =>
    {
        return numeral(value).format('$0,0.00');
    },
    formatNoDecimalCurrency: (value) =>
    {
        return numeral(value).format('$0,0');
    },
    formatHoursMinutesSeconds: (milliseconds) => 
    {
       let number = Number(milliseconds / 1000);
        
        let h = Math.floor(number / 3600);
        let m = Math.floor(number % 3600 / 60);
        let s = Math.floor(number % 3600 % 60);

        let hours = h > 0 ? h + "h " : "";
        let minutes = m > 0 ? m + "m " : "";
        let seconds = s > 0 ? s + "s" : "";
        
        return hours + minutes + seconds; 
    },
    merge: (a, b) => 
    {
        return Object.assign({}, a, b);
    },
    serializeFormData: (formData) =>
    {
        var object = {};
            
        formData.forEach((value, key) => 
        {
            // Reflect.has in favor of: object.hasOwnProperty(key)
            if(!Reflect.has(object, key))
            {
                object[key] = value;
                
                return;
            }
            
            if(!Array.isArray(object[key]))
            {
                object[key] = [object[key]];    
            }
            
            object[key].push(value);
        });
        
        return object;
    },
    url: (base, params) => 
    {
        let queryString;
        
        if (params)
        {
            queryString = _$.param(params);
            
            return base + "?" + queryString;
        }
        
        return base;
    },
    toDayDateTimeString: (dateTime) => {
        return moment.utc(dateTime).format("MMMM D, YYYY, h:mm A");
    },
    toDateString: (dateTime, separator) => {
        
        if (!_.isEmpty(separator))
        {
            return moment.utc(dateTime).format("YYYY" + separator + "MM" + separator + "DD");
        }
        
        return moment.utc(dateTime).format("YYYY-MM-DD");
    },
    toFormattedDateString: (dateTime) =>
    {
        return moment.utc(dateTime).format("MMMM D, YYYY");
    },
    toIconList: (html, icon_class) => 
    {
        html = _.replace(html, /<ul>/g, '<ul class="list-unstyled mb-0">');
        html = _.replace(html, /<li>/g, '<li><i class="' + icon_class + '"></i>');
        
        return html;
    },
    toMonthDateString: (dateTime) =>
    {
        return moment.utc(dateTime).format("MMM D");
    },
    toTimeString: (dateTime) => {
        return moment.utc(dateTime).format("h:mmA");
    },        
    timeFromNow: (dateTime) =>
    {
        return moment.utc(dateTime).fromNow();
    },
    requestPath: () =>
    {
        return window.location.href.split('?')[0];
    }
};



// WEBPACK FOOTER //
// ./resources/js/components/Helpers/Helpers.js